import React from 'react';
import { BoxIcon, PackageIcon, UsersIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { SectionHeading } from './ui/SectionHeading';
import { WHATSAPP_ORDER_LINK } from '../utils/whatsapp';
const packs = [{
  icon: BoxIcon,
  title: 'Caja de 6 empanadas',
  text: 'Ideal para probar varios sabores.'
}, {
  icon: PackageIcon,
  title: 'Caja de 12 empanadas',
  text: 'Perfecta para compartir.'
}, {
  icon: UsersIcon,
  title: 'Pedido para reuniones',
  text: 'Contanos cuántas personas son y te ayudamos a elegir.'
}];
export function Packs() {
  return <section id="cajas" className="w-full scroll-mt-24 bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-89" data-mp="2gt1jd13qceri">
      <div className="mx-auto w-full max-w-6xl" data-id="element-90" data-mp="2ct145e8t3zje">
        <SectionHeading title="Armá tu caja" subtitle="Perfectas para compartir, llevar a una reunión o resolver un antojo de la semana." data-id="element-91" data-mp="2qs0rmikl28dz" />

        <div className="mt-10 grid gap-4 sm:grid-cols-3" data-id="element-92" data-mp="2lr303fdoo1zt">
          {packs.map(({
          icon: Icon,
          title,
          text
        }) => <div key={title} className="flex h-full flex-col rounded-2xl border border-aqua-200 bg-cream p-6 shadow-soft" data-id="element-93" data-mp="3cyv0gm1vmwgo">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-gold-400/50 bg-white text-aqua-600" data-id="element-94" data-mp="3hwegnri4xjb9">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-95" data-mp="3qynmi42gkoib" />
              </span>
              <h3 className="mt-4 font-display text-[18px] uppercase tracking-wide text-night-900" data-id="element-96" data-mp="3qwjjdocdvtj3">
                {title}
              </h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-muted" data-id="element-97" data-mp="4it549rv45ls">
                {text}
              </p>
              <div className="mt-5 h-px w-full bw-gold-rule" aria-hidden="true" data-id="element-98" data-mp="9guoywx448yb" />
              <CtaButton href={WHATSAPP_ORDER_LINK} size="sm" track="whatsapp-pack-click" className="mt-5 w-full" aria-label={`Consultar ${title} por WhatsApp`} data-id="element-99" data-mp="dkiyhl5b1em7">
                Consultar por WhatsApp
              </CtaButton>
            </div>)}
        </div>
      </div>
    </section>;
}